import React, { useCallback } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import api, { apiAction } from '../../api'
import { UserIcon, LogoutIcon } from '../icons'

import S from './styled'

const Logout = ({ userName, logout, history }) => {

  const doLogout = useCallback(e => {
    e.stopPropagation()
    e.preventDefault()
    logout()
    history.push('/login')
    return false
  }, [logout, history])

  return (
    <S.Logout>
      <div><UserIcon /></div>
      <span>{userName}</span>
      <a href="#/login" onClick={doLogout} title="Logout"><LogoutIcon /></a>
    </S.Logout>
  )
}


const mapStateToProps = state => ({
  userName: state.session.userName,
})

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(apiAction(api.logout)(null, { quite: true })),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Logout))
